import script from "./Label.vue?vue&type=script&lang=ts&setup=true"
export * from "./Label.vue?vue&type=script&lang=ts&setup=true"

import "./Label.vue?vue&type=style&index=0&id=ddbe4cd4&scoped=true&lang=scss"

import exportComponent from "/var/icar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ddbe4cd4"]])

export default __exports__